import { BeforeNotifyHandler } from '@honeybadger-io/core/build/src/types';

/**
 * This gives us a quick solution to ignore certain Honeybadger errors reactively.
 * Anytime we see a Honeybader notice that we want to ignore, add its "message"
 * property to this array and add an inline comment linking to the notice.
 */
const ignoredHbNoticeMessages = [
  'Invalid login credentials', // https://app.honeybadger.io/projects/99139/faults/84801994
];

export const beforeNotifyHandler: BeforeNotifyHandler = (notice) => {
  if (notice && ignoredHbNoticeMessages.includes(notice.message)) {
    return false;
  }
};
